import { VALIDATION_MESSAGES } from '@zorro/common-utils';
import { YesNo } from '@zorro/types';
import * as yup from 'yup';

export const finchSetupFormSchemaObject = yup.object({
  earliestEnrollmentsSyncDate: yup.date().optional(),
  earlyEnrollmentsOffset: yup
    .string()
    .typeError(VALIDATION_MESSAGES.earlyEnrollmentsOffset)
    .required(VALIDATION_MESSAGES.earlyEnrollmentsOffset),
  enforcePostTaxDeductions: yup
    .mixed<YesNo>()
    .oneOf(Object.values(YesNo), VALIDATION_MESSAGES.enforcePostTaxDeductions)
    .required(),
  isHsaDeductions: yup.boolean().required(),
});

export type FinchSetupFormFields = yup.InferType<
  typeof finchSetupFormSchemaObject
>;

export const earlyEnrollmentsOffsetOptions: {
  value: string;
  label: string;
}[] = [
  { value: '21', label: '20 days before pay period end' },
  { value: '20', label: '19 days before pay period end' },
  { value: '19', label: '18 days before pay period end' },
  { value: '18', label: '17 days before pay period end' },
  { value: '17', label: '16 days before pay period end' },
  { value: '16', label: '15 days before pay period end' },
  { value: '15', label: '14 days before pay period end' },
  { value: '14', label: '13 days before pay period end' },
  { value: '13', label: '12 days before pay period end' },
  { value: '12', label: '11 days before pay period end' },
  { value: '11', label: '10 days before pay period end' },
  { value: '10', label: '9 days before pay period end' },
  { value: '9', label: '8 days before pay period end' },
  { value: '8', label: '7 days before pay period end' },
  { value: '7', label: '6 days before pay period end' },
  { value: '6', label: '5 days before pay period end' },
  { value: '5', label: '4 days before pay period end' },
  { value: '4', label: '3 days before pay period end' },
  { value: '3', label: '2 days before pay period end' },
  { value: '2', label: '1 day before pay period end' },
  { value: '1', label: 'On pay period end' },
  { value: '0', label: '1 day after pay period end' },
  { value: '-1', label: '2 days after pay period end' },
  { value: '-2', label: '3 days after pay period end' },
  { value: '-3', label: '4 days after pay period end' },
  { value: '-4', label: '5 days after pay period end' },
  { value: '-5', label: '6 days after pay period end' },
  { value: '-6', label: '7 days after pay period end' },
  { value: '-7', label: '8 days after pay period end' },
  { value: '-8', label: '9 days after pay period end' },
  { value: '-9', label: '10 days after pay period end' },
  { value: '-10', label: '11 days after pay period end' },
  { value: '-11', label: '12 days after pay period end' },
  { value: '-12', label: '13 days after pay period end' },
  { value: '-13', label: '14 days after pay period end' },
  { value: '-14', label: '15 days after pay period end' },
  { value: '-15', label: '16 days after pay period end' },
  { value: '-16', label: '17 days after pay period end' },
  { value: '-17', label: '18 days after pay period end' },
  { value: '-18', label: '19 days after pay period end' },
  { value: '-19', label: '20 days after pay period end' },
];
